import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getPerformance } from "firebase/performance";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};
// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const projectFirestore = getFirestore(app); // Firestore database
const projectAuth = getAuth(app); // Authentication
const projectStorage = getStorage(app); // Storage
const functions = getFunctions(app, "asia-southeast1"); // Cloud Functions
const performance = getPerformance(app); // Performance Monitoring

// Export services for use in other components
export {
  app,
  projectFirestore,
  projectAuth,
  onAuthStateChanged,
  projectStorage,
  functions,
  performance,
};
